import Promise from 'bluebird';
import _ from 'lodash';

import api from '../../api';
import infoBoard from '../../core/infoboard';
import worldMap from '../../core/map';
import translate from '../../core/tools/translate';
import templates from '../../core/templates';
import environment from '../../environment';
import { customScrollbar, isLayerEnabled } from '../../shared';
import { selectMarker } from '../../shared/map';
import moment from 'moment';
import { FeaturePermission } from '../../../constants/feature.permission.helper';
import dialog from '../../core/dialog';
import { MulticriteriaTypesMap } from '../../../enuns/AfterSales/multicriteriaTypes.enum';
import { CONFIG } from '../../../config';

const name = 'MulticriteriaAfterSales';

const LayerControls = (name) => require('../../controls').get(name);
const LayerInfo = (name) => require('../../info').get(name);

const currentLayer = () => LayerControls(name).getLayer();
const isAuthorized = (permission, feature) => api.authorization.isAuthorized(permission, feature);

const multicriteriaTypes = [
    { value: 1, name: translate(`Common.${MulticriteriaTypesMap.autoParts}`), visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreAutoparts) },
    { value: 2, name: translate(`Common.${MulticriteriaTypesMap.tireRetail}`), visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireRetail) },
    { value: 3, name: translate(`Common.${MulticriteriaTypesMap.tireTruck}`), visible: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.showScoreTireTruck) },
];

const _getContainer = () =>
    infoBoard.createContainer({
        id: 'multicriteria',
        name: translate('Common.MulticriteriaAfterSales')
    });

const _getImage = latlng =>
    new Promise((resolve) => {
        const images = {
            original: '#',
            thumbnail: `https://maps.googleapis.com/maps/api/streetview?size=${worldMap.getThumbImageSize()}&location=${latlng.lat},${latlng.lng}&sensor=false&key=${CONFIG.GOOGLE_MAPS_API_KEY}`
        };
        return resolve(images);
    });

const _getMulticriteriaCalculated = (multicriteriaId, type) => {
    return api.afterSales.get.multicriteria.getCalculateds(multicriteriaId, type);
};

const _getInfo = (feature) => {
    const data = {};
    const {
        geometry: { coordinates },
        properties: {
            Id,
            Name,
            Address,
            StateAcronym,
            Neighborhood,
            City,
            Type
        },
    } = feature;

    data.information = {
        tipo: Type
    };

    data.location = {
        latitude: coordinates[1],
        longitude: coordinates[0],
    };

    data.address = {
        endereco: Address,
        bairro: Neighborhood,
        cidade: City,
        uf: StateAcronym
    };

    data.id = Id;
    data.name = Name;

    return { ...feature, ...data };
};

class MulticriteriaAfterSalesInfo {
    static getInstance() {
        if (!MulticriteriaAfterSalesInfo._instance) {
            MulticriteriaAfterSalesInfo._instance = new MulticriteriaAfterSalesInfo();
        }

        return MulticriteriaAfterSalesInfo._instance;
    }

    init() { }

    _getFeatureLayer(feature) {
        return currentLayer().getLayer(feature.properties.Id);
    }

    openDialogWithOptionsOfMulti(features) {
        const visibleOptions = multicriteriaTypes
            .filter(x => x.visible)
            .map((x, i) => ({ value: x.value, text: x.name }));

        if (visibleOptions.length === 0) {
            return;
        }

        dialog.select(visibleOptions, chosenOption => {
            const selectedType = multicriteriaTypes.find(x => x.value === chosenOption);
            const optionName = selectedType ? selectedType.name : chosenOption;

            api.afterSales.get.multicriteria.exportXls(
                features.map(x => x.properties.Id),
                chosenOption,
                `${environment.get('CONFIG.CLIENT')}_Sumario Multicriterio_${optionName}_v${moment().format(
                    'YYYYMMDD'
                )}.xlsx`
            );
        });
    }

    create(features) {
        if (infoBoard.locked) {
            return;
        }

        const container = _getContainer();

        if (
            infoBoard.dataUnavailable({
                features,
                container,
                isEnabled: isLayerEnabled(name)
            })
        ) {
            return;
        }

        const _entry = {};

        const template = $(
            templates('infoboard-content', {
                id: 'points-collapse',
                actions: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.export)
            })
        );
        const content = template.find('.panel-group');

        features.forEach(feature => {
            let item;
            let layer = this._getFeatureLayer(feature);

            let options = {
                feature,
                name: name.toLocaleLowerCase(),
                originalName: name,
                container,
                controls: {
                    info: true,
                    summary: false,
                    compare: false,
                    hideStore: true
                }
            };

            item = infoBoard.createItem(options);
            if (!item) {
                return;
            }

            _entry[feature.properties.Id] = feature;

            if (item.btn.info) {
                item.btn.info.on('click', e => {
                    e.preventDefault();
                    const queue = [];
                    const coordinates = {
                        lat: feature.geometry.coordinates[1],
                        lng: feature.geometry.coordinates[0]
                    };

                    // queue.push(_getImage(coordinates));
                    queue.push(_getMulticriteriaCalculated(feature.properties.Id, 2));

                    Promise.all(queue).then(response => {
                        const data = _getInfo(feature);
                        // data.image = response[0];
                        data.scoreCalculated = response[0];
                        data.name = feature.properties['Name'].toCapitalCase();
                        data.id = feature.properties['Id'];
                        LayerInfo('ResumeAfterSales').show(data, {
                            resultType: 'Multicriteria',
                            visible: true,
                            title: translate('Common.PointInfo'),
                            latlng: coordinates,
                            callbackBack: () => {
                                infoBoard.showInfo('Multicriteria', feature.properties.Id);
                                worldMap.getCurrent().fireEvent('click');
                            }
                        });
                    });

                    selectMarker(layer, feature, name, 'points');
                });
            }

            if (item.btn.hideStore) {
                if (currentLayer().isHidden(feature.properties.Id)) {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye-slash');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.ShowStore'));
                    item.title.toggleClass('disabled');
                }

                if (!currentLayer().isHidden(feature.properties.Id)) {
                    $(item.btn.hideStore).parent().find('i').toggleClass('fa-eye');
                    $(item.btn.hideStore).parent().find('a').text(translate('Action.HideStore'));
                }

                item.btn.hideStore.on('click', () => {
                    LayerControls(name).toggleVisibility(feature.properties.Id, layer);
                    if (!layer) {
                        layer = this._getFeatureLayer(feature);
                    }
                });
            }

            $(content).append(item.layout);
        });

        $(container).detach().append(template).appendTo('#infoboard-content');

        if (isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.export)) {
            const actions = infoBoard.createActions(
                {
                    export: {
                        value: isAuthorized(FeaturePermission.LAYER_AFTER_SALES_MULTICRITERIA.export),
                        label: translate('Action.Export')
                    }
                },
                'MulticriteriaAfterSales'
            );
            actions.layout.appendTo(container);

            if (actions.export) {
                actions.export.on('click', e => {
                    e.stopPropagation();
                    this.openDialogWithOptionsOfMulti(features);
                });
            }
        }

        customScrollbar(content);
    }
}

export default MulticriteriaAfterSalesInfo;



// WEBPACK FOOTER //
// ./src/scripts/info/AfterSales/MulticriteriaAfterSalesInfo.js